import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { Controller } from 'react-hook-form';
import { TextField } from '@mui/material';
import theme from 'Styles/theme';

const SupplementConfig = ({ control, errors }) => {
  const intl = useIntl();

  return (
    <>
      <Controller
        name="supplementName"
        control={control}
        defaultValue=""
        rules={{
          required: intl.formatMessage({ id: 'error.min-characters' }, { min: 3 }),
          minLength: { value: 3, message: intl.formatMessage({ id: 'error.min-characters' }, { min: 3 }) },
          maxLength: { value: 100, message: intl.formatMessage({ id: 'error.max-characters' }, { max: 100 }) },
        }}
        render={({ field: { value, onChange, ref } }) => (
          <TextField
            inputRef={ref}
            inputProps={{ 'aria-label': intl.formatMessage({ id: 'reminders.supplement-name' }) }}
            value={value}
            onChange={onChange}
            placeholder={`${intl.formatMessage({ id: 'reminders.supplement-name' })} *`}
            variant="outlined"
            error={!!errors.supplementName}
            sx={{
              '.MuiInputBase-input::placeholder': {
                color: errors.supplementName ? `${theme.palette.error.main}` : 'inherit',
              },
            }}
            helperText={errors.supplementName?.message}
          />
        )}
      />
      <Controller
        name="supplementDose"
        control={control}
        defaultValue=""
        rules={{
          maxLength: { value: 30, message: intl.formatMessage({ id: 'error.max-characters' }, { max: 30 }) },
        }}
        render={({ field: { value, onChange, ref } }) => (
          <TextField
            inputRef={ref}
            inputProps={{ 'aria-label': intl.formatMessage({ id: 'reminders.supplement-dose' }) }}
            value={value}
            onChange={onChange}
            placeholder={intl.formatMessage({ id: 'reminders.supplement-dose' })}
            variant="outlined"
            helperText={errors.supplementDose?.message}
          />
        )}
      />
    </>
  );
};

SupplementConfig.propTypes = {
  control: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

export default SupplementConfig;
